import { Statuses } from "src/@types/deals";
import { sortingTrns } from "./trns";

export const SORTING_OPTIONS = [
  {
    id: "1",
    value: "-created_at",
    label: "Newest First",
  },
  {
    id: "2",
    value: "created_at",
    label: "Older First",
  },
  {
    id: "3",
    value: "clone_cost",
    label: "Low price First",
  },
  {
    id: "4",
    value: "-clone_cost",
    label: "High price First",
  },
  //   {
  //     id: "5",
  //     value: "Recommend",
  //     label: "Recommend",
  //   },
];

export const INQUIRIES_SORTING_OPTIONS = [
  {
    id: "1",
    value: "-created_at",
    label: "Newest First",
  },
  {
    id: "2",
    value: "created_at",
    label: "Older First",
  },
  {
    id: "3",
    value: "inquiry_cost",
    label: "Low price First",
  },
  {
    id: "4",
    value: "-inquiry_cost",
    label: "High price First",
  },
  //   {
  //     id: "5",
  //     value: "Recommend",
  //     label: "Recommend",
  //   },
];

export const SORTING_STATUS_OPTIONS = [
  {
    id: "1",
    value: "",
    label: "All",
  },
  {
    id: "2",
    value: Statuses.DONE,
    label: "Done",
  },
  {
    id: "3",
    value: Statuses.IN_PROGRESS,
    label: "In Progress",
  },
  {
    id: "4",
    value: Statuses.NEW_REQUEST,
    label: "New Request/Pending",
  },
  {
    id: "5",
    value: Statuses.SUSPENDED,
    label: "Suspended",
  },
  {
    id: "6",
    value: Statuses.CANCELED,
    label: "Canceled",
  },
];

export const getSortLabel = (isStatus: boolean) => {
  if (isStatus) {
    return sortingTrns.status;
  } else {
    return sortingTrns.sortBy;
  }
};
